import { session } from '@/composables/useSession'
import i18n from '@/i18n'

export const cmdKey = navigator.userAgent.includes('Mac') ? '⌘' : 'Ctrl'
export const ctrlKey = navigator.userAgent.includes('Mac') ? '^' : 'Ctrl'
export const newPinCombo = [cmdKey, 'P']
export const togglePageNavCombo = ['⇧', 'S']
const hideSubnav = [ctrlKey, '[']
const showSubnav = [ctrlKey, ']']
export const toggleCommandPaletteCombo = [cmdKey, 'K']

export default () => [
  {
    combo: ['⇧', '?'],
    description: i18n.t('modules.application.shortcuts.toggle_shortcuts'),
  },
  ...(!session.features.zendeskUiNavigation
    ? [
        {
          combo: toggleCommandPaletteCombo,
          description: i18n.t('modules.application.shortcuts.command_palette'),
        },
      ]
    : []),
  ...(session.features.zendeskUiNavigation
    ? [
        {
          combo: hideSubnav,
          description: i18n.t('modules.application.shortcuts.hide_subnav'),
        },
        {
          combo: showSubnav,
          description: i18n.t('modules.application.shortcuts.show_subnav'),
        },
      ]
    : [
        {
          combo: togglePageNavCombo,
          description: i18n.t('modules.application.shortcuts.hide_show_subnav'),
        },
      ]),
  {
    combo: ['→'],
    alternative: ['J'],
    description: i18n.t('modules.application.shortcuts.next_conversation'),
  },
  {
    combo: ['←'],
    alternative: ['K'],
    description: i18n.t('modules.application.shortcuts.previous_conversation'),
  },
  {
    combo: ['R'],
    description: i18n.t('modules.application.shortcuts.shuffle_list'),
  },
  {
    combo: [cmdKey, '⇧', 'E'],
    description: i18n.t('modules.application.shortcuts.expand_editor'),
  },
  {
    combo: [cmdKey, '⇧', 'O'],
    description: i18n.t('modules.application.shortcuts.open_original_conversation'),
  },
  {
    combo: [cmdKey, '⇧', '↑'],
    description: i18n.t('modules.application.shortcuts.rate_highest'),
  },
  {
    combo: [cmdKey, '⇧', '↓'],
    description: i18n.t('modules.application.shortcuts.rate_lowest'),
  },
  {
    combo: newPinCombo,
    description: i18n.t('modules.application.shortcuts.add_pin'),
  },
]
